import { UpdateAdditionalModalComponent } from './../update-additional-modal/update-additional-modal.component';
import { AddRemoveExtrasModalComponent } from './../add-remove-extras-modal/add-remove-extras-modal.component';
import { ModifyPickupModalComponent } from './../modify-pickup-modal/modify-pickup-modal.component';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { ViewBookingViewModeEnum } from 'src/app/models/enums/ViewBooking/ViewBookingEnum';
import { Subscription } from 'rxjs';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { PredefinedAdditionalServiceEnum } from 'src/app/models/enums/BookingEnums';


@Component({
  selector: 'modification-type-modal',
  templateUrl: './modification-type-modal.component.html',
  styleUrls: ['./modification-type-modal.component.scss']
})
export class ModificationTypeModalComponent implements OnInit,OnDestroy {


  faTimesCircle=faTimesCircle;
  subscriptions:Subscription[]=[];
  viewBooking: ViewBookingModel;
  isHavingAdditionalDriver: boolean;
  constructor(private searchService: SearchService,private bookingService:BookingService,private dialogRef: MatDialogRef<ModificationTypeModalComponent>,
    private authService: AuthService, private router: Router, private formBuilder: FormBuilder,public translateService: TranslateService,private domSanitizer: DomSanitizer, private route: ActivatedRoute,
    private dialog: MatDialog ) {
  }


  ngOnInit() {
    this.subscriptions.push(this.bookingService.viewBookingModel.subscribe(res => {

      this.viewBooking = res;
      this.isHavingAdditionalDriver=this.checkAdditionalDriver(res);


    }));
  }
  checkAdditionalDriver(res: ViewBookingModel): boolean {
    let additionalServices=res.lstAdditionalServiceReservationCase;
    if(additionalServices!=null&&additionalServices.length>0){
      return additionalServices.filter(a => a.predefinedAdditionalServiceID==PredefinedAdditionalServiceEnum.AdditionalDrivers)[0]!=null;
    }
    return false;
  }

  close(): void {
    this.dialogRef.close();
  }

  ModifyPickup(){

    //Open Modify pickup modal and listien if on closing it returned true then it updated the case
    //We should close all the popups becasue the data updated
    //ELSE keep the parent popup open

    // const dialogRef = this.dialog.open(ModifyPickupModalComponent, {panelClass: 'modify-pickup-modal'});
    // dialogRef.afterClosed().subscribe(
    //   data => {
    //     if (data != null &&data) {
    //       this.close();
    //     }
    //   }
    // );
    // this.dialogRef.close();

    // this.router.navigate(['/update-booking-date']);
    // this.dialogRef.close();
    this.dialogRef.close({option:ViewBookingViewModeEnum.ModifyPickUp});

  }

  AddRemoveExtras(){

    //this.dialog.open(AddRemoveExtrasModalComponent, {panelClass: 'add-remove-extras-modal'});

     //Open Modify pickup modal and listien if on closing it returned true then it updated the case
    //We should close all the popups becasue the data updated
    //ELSE keep the parent popup open
    // const dialogRef = this.dialog.open(AddRemoveExtrasModalComponent, {panelClass: 'add-remove-extras-modal'});
    // dialogRef.afterClosed().subscribe(
    //   data => {
    //     if (data != null &&data) {
    //       this.close();
    //     }
    //   }
    // );
    //this.router.navigate(['/update-booking-extra']);
    this.dialogRef.close({option:ViewBookingViewModeEnum.AddRemoveExtras});

  }

  UpdateAdditional(){

    //this.dialog.open(UpdateAdditionalModalComponent, {panelClass: 'update-additional-modal'});

    // const dialogRef = this.dialog.open(UpdateAdditionalModalComponent,{panelClass: 'update-additional-modal'});
    // dialogRef.afterClosed().subscribe(
    //   data => {
    //     if (data != null &&data) {
    //       this.close();
    //     }
    //   }
    // );

    // this.dialogRef.close();
    // this.router.navigate(['/update-additional-driver']);
    // this.dialogRef.close();
    this.dialogRef.close({option:ViewBookingViewModeEnum.UpdateDriverInfo,
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item =>{
      item.unsubscribe();
    })
  }

}
